import React from 'react';
import sanitizeHtml, { type IOptions } from 'sanitize-html';

const SUPPORTED_SANITIZER_OPTIONS = [
  'allowProtocolRelative',
  'allowedAttributes',
  'allowedClasses',
  'allowedSchemes',
  'allowedSchemesByTag',
  'allowedTags',
  'exclusiveFilter',
  'nonTextTags',
  'parser',
  'selfClosing',
  'transformTags',
] as const;

type SanitizerOptions = Partial<Pick<IOptions, (typeof SUPPORTED_SANITIZER_OPTIONS)[number]>>;

type SanitizedHTMLProps = SanitizerOptions & {
  html?: string;
  className?: string;
  id?: string;
  style?: React.CSSProperties;
};

export default function SanitizedHTML({ html = '', className, id, style, ...rest }: SanitizedHTMLProps) {
  const options: SanitizerOptions = {};
  for (const name of SUPPORTED_SANITIZER_OPTIONS) {
    if (typeof rest[name] !== 'undefined') {
      (options as Record<string, unknown>)[name] = rest[name];
    }
  }

  return (
    <div
      className={className}
      dangerouslySetInnerHTML={{ __html: sanitizeHtml(html, options) }}
      id={id}
      style={style}
    />
  );
}
